import './ServiceContainer.css'

const ServiceContainer = (props) => {
    const openPDF = () => {
        window.open(props.checklist,  '_blank')
    }
    const openTemplate = () => {
        window.open(props.template, '_blank')
    }
    const openEnhancedTemplate = () => {
        window.open(props.enhanced_template, '_blank')
    }
    const openSecondEnhancedTemplate = () => {
        window.open(props.second_enhanced_template, '_blank')
    }


  return (
      <div className = 'service-types'>
          <div className= 'service-type-container'>
              <img alt = 'cow' src = {props.img} />
              <div className= 'service-icon'>
                  <img alt = 'service-icon' src = {props.icon} />
              </div>
          </div>
          <div className= 'service-type-details'>
              <h1> {props.type} </h1>
              {/*<p> {props.desc} </p>*/}
              <div className= 'biosecurity-checklist'>
                  <p> {props.checklist_name} </p>
                  <div className= 'open-new-page' onClick= {openPDF} />
              </div>
              <div className= 'biosecurity-template'>
                  <p> {props.template_name} </p>
                  <div className= 'file-download-icon' onClick= {openTemplate} />
              </div>

              {props.enhanced_template_name !== undefined && <div className= 'biosecurity-template'>
                  <p> {props.enhanced_template_name} </p>
                  <div className= 'file-download-icon' onClick= {openEnhancedTemplate} />
              </div>}

              {props.second_enhanced_template_name !== undefined  && <div className= 'biosecurity-template'>
                  <p> {props.second_enhanced_template_name} </p>
                  <div className= 'file-download-icon' onClick= {openSecondEnhancedTemplate} />
                  </div>
              }

          </div>
      </div>
  )
}

export default ServiceContainer;
